import { FormControl, FormControlLabel, FormHelperText, Switch, SwitchProps, FormControlProps } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';

export type FormSwitchProps = {
  control: Control<any>;
  name: string;
  label: string;
  helperText?: string;
  disabled?: boolean;
  switchProps?: Partial<SwitchProps>;
} & Omit<FormControlProps, 'name'>;

export const FormSwitch = ({
  control,
  name,
  label,
  helperText,
  disabled,
  switchProps,
  ...formControlProps
}: FormSwitchProps) => {
  const resolveErrorMessage = useErrorMessageResolver();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, ref, onChange, ...fieldRest }, fieldState: { error } }) => (
        <FormControl fullWidth {...formControlProps} error={!!error}>
          <FormControlLabel
            control={
              <Switch
                {...switchProps}
                {...fieldRest}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
                inputRef={ref}
              />
            }
            label={label}
          />
          {(error?.message || helperText) && (
            <FormHelperText error={!!error?.message}>
              {error?.message ? resolveErrorMessage(error.message) : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};
